import { render } from "./SidebarView.vue?vue&type=template&id=31c83888"
import script from "./SidebarView.vue?vue&type=script&lang=js"
export * from "./SidebarView.vue?vue&type=script&lang=js"

import "./SidebarView.vue?vue&type=style&index=0&id=31c83888&lang=css"

import exportComponent from "/home/runner/work/adoranwodo2.0/adoranwodo2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__